import { reactive } from 'vue';

const recentlySaved = reactive<CourseAndFirm[]>(
  JSON.parse(localStorage.getItem('recently-saved') || '[]')
);

export const updateRecentlySaved = ({ courseId, firmCode }: CourseAndFirm) => {
  const newRecentlySaved = [
    { courseId, firmCode },
    ...recentlySaved.filter(
      ({ courseId: c, firmCode: f }) => c !== courseId || f !== firmCode
    )
  ].slice(0, 8);

  localStorage.setItem('recently-saved', JSON.stringify(newRecentlySaved));
  return newRecentlySaved;
};

export const getRecentlySaved = () => {
  return recentlySaved;
};
